import type { CloseDetails } from './typings'

export const closeDetailsActionCreator = (): CloseDetails => ({
  type: 'activities/closeDetails',
})
